import { render, staticRenderFns } from "./UserLocationAccessSection.vue?vue&type=template&id=921ab71c&scoped=true"
import script from "./UserLocationAccessSection.vue?vue&type=script&lang=js"
export * from "./UserLocationAccessSection.vue?vue&type=script&lang=js"
import style0 from "./UserLocationAccessSection.vue?vue&type=style&index=0&id=921ab71c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921ab71c",
  null
  
)

export default component.exports